'use client';

import { useAppContext } from '~/contexts/AppContext/AppContext';

const DEVICE_TYPE = {
  a: 'android',
  i: 'ios',
  m: 'mobile_web',
  w: 'pc_web',
} as const;

export const useEnvironmentInfo = () => {
  const { appLogContext } = useAppContext();

  const deviceType = DEVICE_TYPE[appLogContext?.device_type || 'w'];

  return {
    // 클라이언트 사이드에서 웹뷰 여부 판단할 수 있기 전까지는 true로 설정
    isWebview: !!appLogContext?.app_id,
    deviceType,
    isIos: deviceType === 'ios',
    isAndroid: deviceType === 'android',
  } as const;
};
